module.exports = __webpack_public_path__ + "static/Roboto-Regular-39e0c457cfb66f42d70232b2be0a8e54.woff2";